var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { combineSxProps } from "../../Utils";
const attentionBoxActionsSxProps = (isSpaced) => ({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: isSpaced ? "space-between" : "flex-end",
    gap: "4px",
    color: "text.primary"
});
export const AttentionBoxActions = (props) => {
    const { isSpaced, children, sx } = props, boxProps = __rest(props, ["isSpaced", "children", "sx"]);
    return (_jsx(Box, Object.assign({}, boxProps, { sx: combineSxProps(attentionBoxActionsSxProps(isSpaced), sx), children: children })));
};
//# sourceMappingURL=AttentionBoxActions.js.map